<template lang="pug">
    v-dialog( persistent max-width="1250px" v-model="open" )
        v-toolbar( color="primary" dark sticky flat )
            v-toolbar-title Detalle de cuenta contable
            v-spacer
            v-btn( icon dark @click="toggleOpen")
                v-icon close
        crud-form(
            :fields="fields"
            ref="refCFShowAccountDetails"
            :editable="isEditable"
            :noButtons="!isEditable"
            readOnly
            @submitForm="submitUpdateAccount"
            submitText="Guardar"
            )
</template>

<script>
//-
import { CrudForm } from '@/components/reusable_components'
import { mapActions, mapState } from 'vuex'
import {
    fetchAllParents,
    getAllAccountTypes,
    updateAccounts,
} from '@/services/api/account'
import FieldsShowAccount from './FieldsShowAccountDetails'
//-
export default {
    name: 'dialog-account-details',
    props: {
        accountObj: {
            type: Object,
            required: true,
        },
    },
    data: function() {
        return {
            open: false,
            fields: FieldsShowAccount,
            editableValue: false,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        isEditable: {
            get: function() {
                return this.editableValue && this.$can('EDIT_ACCOUNT')
            },
            set: function(val) {
                this.editableValue = val
            },
        },
    },
    methods: {
        // -- UI Modification
        submitUpdateAccount: function() {
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Guardar')
            let payload = this.fillSnack(
                'warning',
                '¿Desea guardar y actualizar cambios?',
                ''
            )
            this.initSnackbar(payload)
        },
        // -- Data fetching
        getInfoFields: async function() {
            let allParents = await fetchAllParents()
            let allTypes = await getAllAccountTypes()
            this.setFieldOptionsData(0, allTypes.data)
            this.setFieldOptionsData(1, allParents.data)
        },
        fillFields: function(data) {
            this.fields[0].value = data.acc_account_type_id
            this.fields[1].value = isNaN(data.acc_parent_id)
                ? null
                : data.acc_parent_id
            this.fields[2].value = data.code
            this.fields[3].value = data.comment
            this.fields = [...this.fields]
        },
        // -- Data handling and transformations
        // -- Validations and Error handling
        isEditSwitchEditable: function(data) {
            this.isEditable = data.modifiable ? true : false
        },
        // -- Other functions
        toggleOpen: function() {
            this.open = !this.open
            this.$refs.refCFShowAccountDetails.editSwitch = false
        },
        showSnackbar: function(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },
        setFieldOptionsData(index, data) {
            this.fields[index].options.data = data
        },
        // -- Vuex mappings
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        open(val) {
            if (val == true) {
                // load info about account
                this.isEditSwitchEditable(this.accountObj)
                this.getInfoFields()
                this.fillFields(this.accountObj)
            }
        },
        async responseConfirm(val) {
            //-
            if (val === 'Guardar') {
                this.resetSnackbarState()
                let obj = {}
                obj.code = this.$refs.refCFShowAccountDetails.vmodels.code
                obj.comment = this.$refs.refCFShowAccountDetails.vmodels.comment
                obj.acc_account_type_id = this.$refs.refCFShowAccountDetails.vmodels.acc_account_type_id
                obj.acc_parent_id = isNaN(
                    this.$refs.refCFShowAccountDetails.vmodels.acc_parent_id
                )
                    ? null
                    : this.$refs.refCFShowAccountDetails.vmodels.acc_parent_id
                if (
                    obj.code !== '' &&
                    obj.comment !== '' &&
                    !isNaN(obj.acc_account_type_id)
                ) {
                    let response = await updateAccounts(this.accountObj.id, obj)
                    //-
                    if (response.status == 'success') {
                        let payload = this.fillSnack(
                            'success',
                            'Cuenta contable creada con éxito',
                            ''
                        )
                        this.initSnackbar(payload)
                        this.$emit('success')
                        this.toggleOpen()
                        // this.$refs.refDTAccountingSeatList.checkAndFetch()
                    } else {
                        let payload = this.fillSnack(
                            'error',
                            'Error',
                            response.error
                        )
                        this.initSnackbar(payload)
                    }
                } else {
                    this.showSnackbar('info', 'Complete datos faltantes', '')
                }
            }
        },
    },
    components: {
        'crud-form': CrudForm,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>